import { objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose } from '../_virtual/_rollupPluginBabelHelpers.js';
import PropTypes from 'prop-types';
import cx from 'classnames';
import React from 'react';
import styles from './LoadingIcon.module.scss.js';
import LoadingIcon from './loading.js';

var _excluded = ["variant", "size", "children", "className"];
var Loading = function Loading(_ref) {
  _ref.variant;
    var size = _ref.size;
    _ref.children;
    var className = _ref.className;
    _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/React.createElement(LoadingIcon, {
    className: cx(className, size && size, styles.loading)
  });
};
Loading.propTypes = {
  /**
   * Color of base element (to determine whether to use light or dark loader)
   */
  variant: PropTypes.oneOf(['primary', 'secondary', 'success', 'danger', 'warning', 'info', 'dark', 'light', 'link', 'facebook', 'github', 'google', 'linkedin', 'twitter']),
  /**
   * Component size presets
   */
  size: PropTypes.oneOf(['sm']),
  /**
   * This component may be used to wrap child elements or components
   */
  children: PropTypes.element,
  /**
   * An ARIA accessible role - typically status
   */
  role: PropTypes.string
};
Loading.defaultProps = {
  role: 'status',
  variant: 'primary'
};

export { Loading as default };
//# sourceMappingURL=index.js.map
